import { combineReducers } from 'redux';
import { user } from './user';
import { account } from './account';
import { autentication } from './autentication';
import { validate } from './validate';
import { login } from './login';
import { logout } from './logout';
import { password } from './password';
import { access } from './access';
import { validateAccess } from './validateAccess';

export default combineReducers({
  user,
  account,
  autentication,
  login,
  logout,
  validate,
  password,
  access,
  validateAccess
});
